import initVideo from './components/video-modal';
import StyledSelect from './components/styled-select';
import Countdown from './components/countdown';
import initCollectors from './components/email-collector';
import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import createHowItWorksCarousel from './components/hiw-carousel';
import createProductFeatures from './components/product-features';
import Accordion from 'marketing/components/Accordion';
import createXhrForm from 'marketing/components/xhrForm';

document.addEventListener('DOMContentLoaded', () => {
    // Initialise video modal
    initVideo();

    // Initialise styled selects
    let element = document.querySelector('[data-styled-select]');
    if (element) {
        new StyledSelect(element);
    }

    // Initialise email collection boxes
    initCollectors();

    // Create a countdown for each [data-countdown] element
    let elements = [].slice.call(document.querySelectorAll('[data-countdown]'));
    elements.forEach((el) => {
        ReactDOM.render(
            <IntlProvider {...global.intlData}>
                <Countdown endDate={el.getAttribute('data-countdown')} />
            </IntlProvider>,
            el
        );
    });

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // Create accordions (FAQ)
    Accordion.create();

    // Product features
    createProductFeatures();

    const agencyForm = document.querySelector('[data-agency-form]');
    if (agencyForm) {
        createXhrForm('[data-agency-form]');
    }
});



/** WEBPACK FOOTER **
 ** ./js/marketing/promotion.jsx
 **/